import { Repository } from '../../../core/context/repository';
import { type AssetRelationType } from './entity';

export class AssetRelationTypes extends Repository<AssetRelationType> {}
